import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';
import messages from './messages';

function RouteCounter({ filter, totalCount, filterCount }) {
  if (!filter) {
    return <b>{totalCount}</b>;
  }
  return (
    <FormattedHTMLMessage
      {...messages.outOf}
      values={{ totalCount, filterCount }}
    />
  );
}
RouteCounter.propTypes = {
  filter: PropTypes.string.isRequired,
  totalCount: PropTypes.number.isRequired,
  filterCount: PropTypes.number.isRequired,
};

RouteCounter.displayName = 'RouteCounter';

export default RouteCounter;
